module.exports = __webpack_public_path__ + "static/silhouette-2-a604d21d94f3842b340ea0a7eb4fa5f6.jpg";